<template>
    <div class="simple-form">
        <el-form :model="authServicerInfo" :rules="authServicerInfoRules" :label-position="'left'" ref="authServicerInfo">
            <div class="form-group">
                <div class="form-label">
                    <label class="required">服务商</label>
                </div>
                <div class="form-value base-line">
                    <el-input class="width-2x" placeholder="请选择服务商" v-model="authServicerInfo.servicerName" disabled></el-input>
                    <i v-if="id == null" class="icon iconfont icon-chazhaobiaodanliebiao" @click="selectServicerInfo"></i>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">授权开始时间</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="dateStart">
                        <el-date-picker v-model="authServicerInfo.dateStart" type="date" placeholder="开始日期"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">授权截止时间</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="dateEnd">
                        <el-date-picker v-model="authServicerInfo.dateEnd" type="date" placeholder="截止日期"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">星级标记</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="starLevel">
                        <el-rate class="mt10" v-model="authServicerInfo.starLevel"></el-rate>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group" style="">
                <div class="form-label">
                    <label>授权业务范围</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="bizDesc">
                        <textarea v-model="authServicerInfo.bizDesc" style="width: 320px;height: 90px"></textarea>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group" style="">
                <div class="form-label">
                    <label>备注</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="memo">
                        <textarea v-model="authServicerInfo.memo" style="width: 320px;height: 90px"></textarea>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { openServicerSelectComnDlg } from '../rentServc/selectDlg'

    import servicerApi from '../../api/servicer'

    export default {
        name: 'swb-auth-servicer-save',
        desc: '授权服务商-新增、编辑',
        props: ['id', 'scope'],
        data: function () {
            let self = this;
            let checkDateStart = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('开始时间不能为空!'));
                } else {
                    callback();
                }
            };
            let checkDateEnd = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    return callback(new Error('截止时间不能为空!'));
                } else if(value.format("yyyy-MM-dd") < self.authServicerInfo.dateStart.format("yyyy-MM-dd")) {
                    callback(new Error('截止时间不能比开始时间小！'));
                } else {
                    callback();
                }
            };
            return {
                authServicerInfo: {
                    dateStart: null,
                    dateEnd: null,
                    starLevel: null,
                },
                authServicerInfoRules: {
                    dateStart: [{validator: checkDateStart, trigger: 'blur'}],
                    dateEnd: [{validator: checkDateEnd, trigger: 'blur'}],
                }
            }
        },
        created: function () {
            let self = this;
            if(!Utils.isNoB(this.id)) {
                let params = {
                    id: this.id
                };
                servicerApi.getAuthServicerInfo(params, function (result) {
                    if(result.type == 'info') {
                        self.authServicerInfo = result.data || {};
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        },
        methods: {
            // 选择服务商
            selectServicerInfo: function () {
                let self = this;
                let showBizRel = false;
                if(!Utils.isNoB(this.scope) && this.scope == 51) {
                    showBizRel = true;
                }
                let params = {
                    showBizRel: showBizRel,
                    showSearch: true,
                    multiSelect: false,
                    multiSelectDisabled: false,
                    initCheckedIds: [],
                };
                openServicerSelectComnDlg(this, params, function (result) {
                    let resultData = result.checkedList;
                    //
                    let authServicerInfo = self.authServicerInfo || {};
                    authServicerInfo.servicerId = resultData.id;
                    authServicerInfo.servicerNo = resultData.no;
                    authServicerInfo.servicerName = resultData.name;
                    self.authServicerInfo = Utils.merge({}, authServicerInfo);
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['authServicerInfo'].validate(function (valid) {
                    if(valid) {
                        if(Utils.isNoB(self.authServicerInfo.starLevel) || self.authServicerInfo.starLevel <= 0) {
                            result.type = "warn";
                            result.message = "星级标记不能为空";
                        } else {
                            result.type = "info";
                            result.data = self.authServicerInfo;
                        }
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servicer/AuthServicerSave.vue